/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown> }} Membership_Friend_Guest_UsedInputs */

const fr_membership_friend_guest_used = /** @type {(inputs: Membership_Friend_Guest_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ce mois-ci : ${i?.used}/${i?.limit} invité(s).`)
};

/**

* @param {Membership_Friend_Guest_UsedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_used = /** @type {((inputs: Membership_Friend_Guest_UsedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_UsedInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_used(inputs)
});